<template>
  <FlashNotification site="admin" :theme="'light'" />
  <div v-if="banner" class="banner-form">
    <div class="banner-info">
      <div class="banner-name">{{ banner.name }}</div>
    </div>

    <div class="fields">
      <ImagePicker
        v-for="field in imagesFields"
        :key="field"
        :field="field"
        :value="field"
        @change="updateBackgroundImage(field)"
      />
      <TextField
        v-for="field in textFields"
        :key="field"
        :field="field"
        :value="field"
        @change="updatePreviewTexts(field)"
      />

      <ColorPicker
        v-for="field in colorFields"
        :key="field"
        :field="field"
        :value="field"
        @change="updatePreviewTexts(field)"
      />

      <NumberField
        v-for="field in numberFields"
        :key="field"
        :field="field"
        :value="field"
        @change="updatePreviewTexts(field)"
      />

      <LinkField
        v-for="field in linkFields"
        :key="field"
        :field="field"
        :value="field"
        @change="updatePreviewTexts(field)"
      />

      <LinkButton
        v-for="field in linkButtons"
        :key="field"
        :field="field"
        :value="field"
        @change="updateButtonText(field)"
      />

      <div class="field">
        <div class="field-name">Public</div>
        <input v-model="banner.published" type="checkbox" />
      </div>
    </div>

    <div class="actions">
      <button @click="updateBanner">Save</button>
    </div>
  </div>
</template>

<script>
import bannersApi from './services/bannersApi'
import TextField from './fields/TextField'
import NumberField from './fields/NumberField'
import LinkField from './fields/LinkField'
import LinkButton from './fields/LinkButton'
import FlashNotification from '../notification/components/FlashNotification'
import { EMITTERS } from '../shared/utils/emitters'
import ColorPicker from './fields/ColorPicker'
import ImagePicker from './fields/ImagePicker'

export default {
  name: 'ManageBannerAppComponent',
  components: {
    ImagePicker,
    ColorPicker,
    FlashNotification,
    TextField,
    NumberField,
    LinkField,
    LinkButton,
  },
  data() {
    return {
      bannerId: parseInt(this.optional_params.banner_id),
      banner: null,
    }
  },
  computed: {
    imagesFields() {
      return this.filterByType('image')
    },
    textFields() {
      return this.filterByType('text')
    },
    colorFields() {
      return this.filterByType('color')
    },
    linkFields() {
      return this.filterByType('link')
    },
    numberFields() {
      return this.filterByType('number')
    },
    linkButtons() {
      return this.filterByType('link_button')
    },
  },
  mounted() {
    bannersApi.getBanner(this.bannerId).then((response) => {
      this.banner = response.data
    })
  },
  methods: {
    filterByType(type) {
      return this.banner.fields.filter((field) => field.field_type === type)
    },
    updateBanner() {
      bannersApi.updateBanner(this.bannerId, this.banner).then((response) => {
        if (response.data.errors && response.data.errors.join(', ')) {
          this.emitter.emit(EMITTERS.SHOW_ERROR_NOTIFICATION_EMITTER, {
            message: response.data.errors.join(', '),
          })
          return
        }
        window.location.reload()

        this.emitter.emit(EMITTERS.SHOW_NOTIFICATION_EMITTER, {
          message: 'Saved',
        })
      })
    },
    updateBackgroundImage(field) {
      $('.donate__block').css({
        'background-image': `url("${field.value.url}")`,
        'background-size': 'cover',
        'background-position': 'center',
        'background-repeat': 'no-repeat',
      })
    },
    updatePreviewTexts(field) {
      const fields = $(`*[field-name=${field.name}]`)
      fields.text(field.value)
    },
    updateButtonText(field) {
      const fields = $(`*[field-name=${field.name}]`)
      fields.text(field.value.label)
    },
  },
}
</script>

<style lang="scss" scoped>
.banner-form {
  width: 500px;
  padding: 10px 40px 10px;
}

.banner-info {
  .banner-name {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }
}
.actions {
  text-align: right;
  padding-right: 10px;
}
.field {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
  .field-name {
    width: 150px;
    text-align: right;
    margin-right: 10px;
  }
  input {
    max-width: 250px;
  }
}
</style>
